export default __webpack_public_path__ + "static/predicting-failures--mobile-1b15261a7600aff1a4e378593a4647a8.png";